import * as Api from '../../api'
import Utils from '../../untils'
import Vue from 'vue'
import md5 from 'js-md5'
const u = Utils.loadLocal(Api.Keys.USER, {});

//const Account = Utils.loadLocal(Api.Keys.token, {});
const state = {
  showLogin: false,
  token: '',
  role:'',//账号类型
  rolePermission:'',
  stripeId: '',//stripeID
  userId: '',
  user: '',
  uploadImgURL:`${process.env.VUE_APP_ROOT_API}/oa/admin/uploadAvatar`,
  uploadBlogImgURL:`${process.env.VUE_APP_ROOT_API}/oa/blog/uploadBlogImage`,
  uploadVideoURL:`${process.env.VUE_APP_ROOT_API}/oa/admin/uploadVideo`,
  uploadPdfURL:`${process.env.VUE_APP_ROOT_API}/oa/admin/uploadFile/0/0`,
  uploadPdfURL1:`${process.env.VUE_APP_ROOT_API}/oa/admin/uploadFile/0/1`,
  uploadPdfURL2:`${process.env.VUE_APP_ROOT_API}/oa/admin/uploadFile/0/0`,
  uploadPdfURL3:`${process.env.VUE_APP_ROOT_API}/oa/admin/uploadFile/0/3`,
};

const getters = {
  userId: state => state.userId,
  user: state => state.user,
  submitData: state => state.submitData,
  isLogin: state => state.isLogin,
  showLogin: state => {
    return state.showLogin && !state.isLogin
  },
  token: state =>state.token,
  role:state=>state.role,
  rolePermission:state=>state.rolePermission,
  stripeId: state => state.stripeId,
  upimgURL: state => state.upimgURL,
  verimg: state => state.verimg,
  upExcel: state => state.upExcel
};

//操作数据的方法
const mutations = {
  setUserId(state, userID){
    state.userId = userID;
    Utils.saveLocal(Api.Keys.USERID, userID ? userID : '')
  },
  setUser(state, user) {
    Utils.saveLocal(Api.Keys.USER, user ? user : {});
    state.user = user;
  },
  setSubmitData(state, data) {
    state.submitData = data;
  },
  updateLoginState(state, loginState) {
    state.isLogin = loginState;
    state.showLogin = false;
  },
  updateLoginshow(state, isShow){
    state.showLogin = isShow;
  },
  settoken(state, token) {
    Utils.saveLocal('token', token ? token : '')
    state.token = token;
  },
  setStripeId(state, stripeId) {
    Utils.saveLocal('stripeId', stripeId ? stripeId : '')
    state.stripeId = stripeId;
  },
  setrole(state,role){
    Utils.saveLocal('role', role ? role : '')
    state.role = role;
  },
  setRolePermission(state,rolePermission){
    Utils.saveLocal('rolePermission', rolePermission ? rolePermission : '')
    state.rolePermission = rolePermission;
  },
  // Add a mutation to clear user data on logout
  clearUserData(state) {
    state.userId = '';
    state.user = '';
    state.token = '';
    state.role = '';
    state.rolePermission = '';
    state.stripeId = '';
    Utils.removeLocal(Api.Keys.USERID); // Clear from local storage
    Utils.removeLocal(Api.Keys.USER);
  }
};

const actions = {

  signIn({state, commit}, {pat, callback}){//登录
    let obj = {
      action: '/oa/admin/login'
    };
    obj.tid =  pat.tid
    obj.code =  pat.code
    obj.password =  pat.password
    obj.userName =  pat.userName
    Api.requestbody(obj).then((resp) => {
      if (callback) {
        callback(resp, 'login')
      }
    });
  },
  getPermission({state, commit}, {pat, callback}){//登录
    let obj = {
      action: '/oa/admin/permission'
    };
    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestget(obj).then((resp) => {
      if (callback) {
        callback(resp, 'getPermission')
      }
    });
  },
  signOut({state, commit}, {pat,callback}){ //登出
    let obj = {
      action: `/oa/admin/logout'`
    };
    Vue.http.headers.common = {webType:'store',token:state.token?state.token:Utils.loadLocal2('token')}
    Api.requestbody(obj).then((resp) => {
      if (callback) {
        callback(resp, 'logOut')
      }
    });
  },


  forgotPassword({state, commit}, {pat, callback}){
    let obj = {
      action: '/oa/admin/forgot'
    };
    obj.email =  pat.email
    Api.requestbody(obj).then((resp) => {
      if (callback) {
        callback(resp, 'forgotPassword')
      }
    });
  },

  updataPassword({state, commit}, {pat,callback}){
    let obj = {
      action: `/oa/admin/upPassword`
    };
    obj.password=pat.password
    obj.email=pat.email

    Vue.http.headers.common = {webType:'store'}
    Api.requestbody(obj).then((resp) => {
      if (callback) {
        callback(resp, 'updataPassword')
      }
    });
  },

  isVerification({state, commit}, {pat,callback}){ //验证码判断
    let obj = {
      action: `/store/password/forgtCode?mobile=${pat.phoneNumber}&code=${pat.code}`
    };
    obj.mobile=pat.phoneNumber
    obj.code=pat.code
    Vue.http.headers.common = {webType:'store'}
    Api.requestget(obj).then((resp) => {
      if (callback) {
        callback(resp, 'isVerification')
      }
    });
  },

  getCode ({state, commit}, {pat, callback}){ //获取短信验证码
    let obj = {
      action: `/join/open/smsCode?toNumber=${pat.toNumber}&type=${pat.type}`,
    };
    Api.requestget(obj).then((resp) => {
      if (callback) {
        callback(resp, 'getCode')
      }
    });
  },

  changeStripeId ({state, commit}, {pat, callback}){ //更新stripedId
    let obj = {
      action: `/orders/adminRestaurant/stripe/${pat.stripeId}`,
    };
    Vue.http.headers.common = {webType:'store',token:state.token?state.token:Utils.loadLocal2('token')}
    Api.requestput(obj).then((resp) => {
      if (callback) {
        callback(resp, 'changeStripeId')
      }
    });
  }
};

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/account.js